import { ProductTypes } from '../../constants/ProductTypes';
import { ActiveProduct } from '../../../models/ActiveProduct';

export const defaultGaugesAcceptedAndOrderedTypes: ProductTypes[] = [
    ProductTypes.AdvancedSignature,
    ProductTypes.SimpleSignature,
    ProductTypes.Batch,
    ProductTypes.PhotoId,
    ProductTypes.CertifiedEmail,
    ProductTypes.SmsCredits,
    ProductTypes.CertifiedSms,
];

const defaultHideableProductsOnExpiration: ProductTypes[] = [ProductTypes.Batch];

const filterAcceptedAndVisibleProducts = (
    activeProducts: ActiveProduct[],
    hideableProductsOnExpiration: ProductTypes[],
    gaugesAcceptedTypes: ProductTypes[]
): ActiveProduct[] => {
    return activeProducts.filter((product: ActiveProduct) => {
        const isAcceptedType = gaugesAcceptedTypes.indexOf(product.type) !== -1;
        const hasCredits = product.quantity - product.usedCredits > 0;
        const hideExpiredCredit = !hasCredits && hideableProductsOnExpiration.indexOf(product.type) !== -1;

        return isAcceptedType && !hideExpiredCredit;
    });
};

const sortAcceptedProducts = (
    filteredProducts: ActiveProduct[],
    gaugesAcceptedTypes: ProductTypes[]
): ActiveProduct[] => {
    return filteredProducts.sort(
        (firstProduct: ActiveProduct, secondProduct: ActiveProduct) =>
            gaugesAcceptedTypes.indexOf(firstProduct.type) - gaugesAcceptedTypes.indexOf(secondProduct.type)
    );
};

export const getAcceptedProducts = (
    activeProducts: ActiveProduct[],
    gaugesAcceptedTypes: ProductTypes[] = defaultGaugesAcceptedAndOrderedTypes,
    hideableProductsOnExpiration: ProductTypes[] = defaultHideableProductsOnExpiration
): ActiveProduct[] => {
    const filteredProducts = filterAcceptedAndVisibleProducts(
        activeProducts,
        hideableProductsOnExpiration,
        gaugesAcceptedTypes
    );

    return sortAcceptedProducts(filteredProducts, gaugesAcceptedTypes);
};

export const isProductAvailable = (productType: ProductTypes, activeProducts: ActiveProduct[]): boolean => {
    return getAcceptedProducts(activeProducts).some(product => product.type === productType);
};

export const hasCreditsAvailable = (productType: ProductTypes, activeProducts: ActiveProduct[]): boolean =>
    !!getAcceptedProducts(activeProducts).find(
        product => product.type === productType && product.usedCredits < product.quantity
    );
